import React from 'react';

import styled from '@emotion/styled';
import { getAssetsPrefix } from '../../../utils/buildVersion';
import { portalUrls } from '../../../utils/locale';

const BadgesContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    width: 100%;
    gap: 48px;

    @media (max-width: 992px) {
        gap: 20px;
    }

    img {
        width: auto;
        height: 44px;

        @media (max-width: 992px) {
            height: 30px;
        }
    }
`;

export const TrustBadges = ({ portal, ...props }: { portal: string }) => {
    if (portal !== portalUrls.nl) {
        return null;
    }
    const assets = getAssetsPrefix();

    const sgrTrustLogo = `${assets}/static/icons/sgr-logo.svg`;
    const anvrTrustLogo = `${assets}/static/icons/anvr-logo.svg`;
    const fondsTrustLogo = `${assets}/static/icons/fonds-logo.svg`;

    return (
        <BadgesContainer {...props}>
            <img src={anvrTrustLogo} alt="" />
            <img src={sgrTrustLogo} alt="" />
            <img src={fondsTrustLogo} alt="" />
        </BadgesContainer>
    );
};
